export default "__VITE_ASSET__Bycpz6dW__"